import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { fetchLeadAnalytics } from "../../../services/automapBuyerAnalyticsApi";
import {
  AdminAnalyticsNav,
  AnalyticsBreakdownTable,
  AnalyticsRangeSelect,
  AnalyticsSummaryGrid,
} from "./AdminAnalyticsShared";

export default function AdminLeadAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchLeadAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar leads analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Analytics de leads"
        description="Leads por fuente, página, campaña y acción de contacto."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="leads" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
          <Link className="dealer-portal-btn" to="/admin/leads">
            Ver inbox operativo
          </Link>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error && totals ? (
          <>
            <AnalyticsSummaryGrid
              items={[
                { label: "Leads", value: totals.leads },
                { label: "Calientes", value: totals.hot },
                { label: "Bad leads", value: totals.bad },
              ]}
            />
            <div className="admin-analytics-grid">
              <AnalyticsBreakdownTable title="Por fuente" rows={payload.bySource} keyLabel="Fuente" />
              <AnalyticsBreakdownTable title="Por tipo de página" rows={payload.byPageType} keyLabel="Página" />
              <AnalyticsBreakdownTable title="Por campaña" rows={payload.byCampaign} keyLabel="Campaña" />
              <AnalyticsBreakdownTable title="Por acción de contacto" rows={payload.byContactAction} keyLabel="Acción" />
              <AnalyticsBreakdownTable title="Por concesionario" rows={payload.byDealer} keyLabel="Dealer" />
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
